import { useIntl } from "react-intl";
import { useLoading } from "../../../components/LoadingContext";
import axios from "../../../api/axiosClient";
import { Modal, Box, Typography, Grid, Button } from "@mui/material";
import PageHeader from "../../ui/PageHeader";
import { errorToast, handleError } from "../../../services/serviceBase";
import { useEffect, useState } from "react";
import SizeAndQty from "../../ui/CreditNote/SizeAndQty";
import toast from "react-hot-toast";

const EditSizesAndQtyModal = (props) => {
    const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 700,
    overflow: "auto",
    p: 4,
    borderRadius: "5px",
  };

  const handleClose = (action) => {
    props.handleCloseModal(action);
  };

  const intl = useIntl();
  const { setLoading } = useLoading();

  const { editData } = props;
  const { idReturnFileHead, returnFileKey, idReturnFileRowList, idInvoiceHeader, invoiceRowNumber } = editData

  const [inoviceSizeQties, setInvoiceSizeQties] = useState([]);
  const [newInvoiceSizeQties, setNewInvoiceSizeQties] = useState([]);
  const [dataAqcuired, setDataAqcuired] = useState(false);

  useEffect(() => {
    if(!dataAqcuired && inoviceSizeQties.length == 0){
      getEditableInvoiceSizeQty();
    }
  }, [dataAqcuired])

  const getEditableInvoiceSizeQty = () => {
    setLoading(true);
    const params = new URLSearchParams();
    params.append('idInvoiceHead', idInvoiceHeader);
    params.append('invoiceRowNumber', invoiceRowNumber);
    idReturnFileRowList.forEach(id => params.append('idReturnFileRows', id));
    
    axios
      .get("/creditnotereturnfiles/"+idReturnFileHead+"/allavailableinvoicesizesqty", {params})
      .then((response) => {
        setLoading(false);
        setInvoiceSizeQties(response.data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });

      setDataAqcuired(true);
  };
  
  const handleChangeQtyInputOfRow = (value, item) => {
    if (value !== "" && value !== null && value !== undefined) {
      var items = []
      var element = inoviceSizeQties.find((x) => x.idArticle == item.idArticle);
      element.requestedQty = Number(value) - element.usedQty;
      items.push(element);
      setNewInvoiceSizeQties([...items]);
    }
  };

  const handleSave = () => {
    setLoading(true);
    axios
      .post(`/creditnotereturnfiles/${idReturnFileHead}/editsizesqty`, newInvoiceSizeQties)
      .then((response) => {
        setLoading(false);
        toast.success(intl.formatMessage({ id: "General.Saved" }))
        handleClose('search');
      })  
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  }

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={returnFileKey} />
        <Grid container spacing={2} sx={{mt:1}}> 
        {inoviceSizeQties.map((item, index) => {
          return (
            <Grid item key={index}>
              <SizeAndQty
                sizeDescription={item.sizeDescription}
                renderedQty={item.usedQty}
                maxQty={item.invoiceQuantity}
                isInEdit={true}
                valueChangedFunction={(e) => handleChangeQtyInputOfRow(e, item)}
                defaultQty={true}
              />
            </Grid>
          );
        })}
        </Grid>
        <Box sx={{ background:'#bcb7b7', color:'white', mt:2}}>
          <Grid container>
          <div style={{ margin: "auto" }}></div>
          <Grid item xs="auto" textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={handleClose}
              >
                [{intl.formatMessage({ id: "General.Cancel" })}]
              </Button>
            </Grid>
            <Grid item xs="auto" textAlign="center">
              <Button
                sx={{ color: "white" }}
                onClick={handleSave}
              >
                [{intl.formatMessage({ id: "General.Save" })}]
              </Button>
            </Grid>
          </Grid>
          
        </Box>
      </Box>
    </Modal>
  );
};

export default EditSizesAndQtyModal;
